import React from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/system";
import Rating from "@mui/material/Rating";
// import reviewIcon from "../assets/review icon.svg";
import { NavLink } from "react-router-dom";
import ChatBubbleIcon from "@mui/icons-material/ChatBubble";

const RootStyle = styled(Box)({
  minHeight: "104px",
  background: "#FFFFFF",
  borderRadius: "10px",
  margin: "3%",
  padding: "0 2%",
  display: "flex",
  alignItems: "center",
  // overflow: "scroll",
});
const ImgBox = styled(Box)({
  minHeight: "62px",
  width: "140px",
  background: "#ebebeb",
  borderRadius: "10px",
  padding: "0 5px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});
const CommentsBox = styled(Box)({
  marginTop: "10px",
  width: "100%",
  height: "27px",
  background: "#444647",
  borderRadius: "0px 10px 10px 0px",
  display: "flex",
  justifyContent: "flex-end",
});
const StarsBox = styled(Box)({
  width: "100%",
  height: "27px",
  background: "#27B1BB",
  borderRadius: "0px 10px 10px 0px",
  display: "flex",
  justifyContent: "space-between",
});

function RatingCard({ examscategory }) {
  return (
    <RootStyle>
      <Stack width="100%" direction="row" spacing={2}>
        <ImgBox>
          {/* <img
            width="30px"
            src={reviewIcon}
            alt="list icon"
            style={{ marginRight: "5px" }}
          /> */}
          <NavLink
            to={`/${encodeURIComponent(
              examscategory.ExamVendorName.replace(/ /g, "-")
            )
              .toLowerCase()
              .replace(/%2b/g, "p")}`}
            style={{
              color: "black",
              textDecoration: "none",
              fontFamily: "poppins",
            }}
          >
            {examscategory?.ExamVendorName}
          </NavLink>
        </ImgBox>
        <Box sx={{ width: "100%", minHeight: "62px", borderRadius: "10px" }}>
          <StarsBox>
            <Rating
              name="read-only"
              sx={{ color: "#ffd500" }}
              value={examscategory.AverageRating}
              precision={0.1}
              readOnly
            />
            <Stack alignItems="center" justifyContent="center">
              <Typography sx={{ color: "#FFFFFF", mt: 0.2, mr: 1 }}>
                {Number.isInteger(examscategory.AverageRating)
                  ? examscategory.AverageRating
                  : examscategory.AverageRating.toFixed(1)}
                /5
              </Typography>
            </Stack>
          </StarsBox>
          <CommentsBox>
            <Stack>
              <ChatBubbleIcon
                sx={{
                  marginTop: "4px",
                  paddingRight: "6px",
                  fontSize: "22px",
                  color: "#F0F0F0",
                }}
              />
              {/* <i
                className="fas fa-comment"
                style=
              ></i> */}
              <Typography
                sx={{
                  color: "#000000",
                  fontSize: "10px",
                  fontWeight: 700,
                  mt: -2.4,
                  ml: 0.6,
                }}
              >
                {examscategory.DiscussionCount}
              </Typography>
            </Stack>
          </CommentsBox>
        </Box>
      </Stack>
    </RootStyle>
  );
}

export default RatingCard;
